import React from 'react';

import { GTMTracking } from '@common/ui/general';

import powerIcon from '@alumni_v2/images/svg/powerIcon.svg';

import styles from './AlumniConnectButton.module.scss';
import { useSelector } from 'react-redux';

const AlumniConnectButton = (params) => {
  const isPaidUser = useSelector((state) => state.reviews.paidUser);

  const {
    handleCardClick,
    name,
    availableForQnA,
  } = params;

  if (availableForQnA && !isPaidUser) {
    return (
      <GTMTracking
        component="div"
        gtmEventType="cta"
        gtmEventAction="click"
        gtmEventResult="acs_modal_open"
        gtmEventCategory="alumni_directory"
        onClick={handleCardClick}
        role="button"
        tabIndex={0}
        className={styles.qNaContaienr}
        gtmEventData={{
          click_type: 'acs_modal_open',
          click_text: name,
          click_section: 'card',
        }}
      >
        <div className={styles.qNaText}>
          Connect 1-1 with
          {' '}
          {name.split(' ')[0]}
        </div>
        <img src={powerIcon} alt="power-icon" />
      </GTMTracking>
    );
  }
  return null;
};

export default AlumniConnectButton;
